var exports = {
  "a": "Box__1MPJqr",
  "P": "isOver__wM07Sj",
};

module.exports = exports;
